import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startCall, hangup } from '../../actions/call.actions';

export default function CallButtonBar({ peerId, peerName, chatId, isGroup = false }) {
    const dispatch = useDispatch();
    const call = useSelector((state) => state.call || { status: 'idle' });

    if (!peerId || isGroup) return null;

    const busy = call.status && call.status !== 'idle';
    const thisPeer = String(call.peerId || '') === String(peerId || '');

    if (call.status === 'in-call' && (thisPeer || !call.peerId)) {
        return (
            <div className="callbar" aria-label="Управление звонком">
                <button
                    type="button"
                    className="callbar__button callbar__button--danger"
                    onClick={() => dispatch(hangup('ended'))}
                    title="Завершить звонок"
                    aria-label="Завершить звонок"
                >
                    ■
                </button>
            </div>
        );
    }

    return (
        <div className="callbar" aria-label="Звонки">
            <button
                type="button"
                className="callbar__button"
                disabled={busy}
                onClick={() => dispatch(startCall({ to: peerId, video: false, chatId }))}
                title={`Аудиозвонок ${peerName || ''}`.trim()}
                aria-label="Аудиозвонок"
            >
                ☎
            </button>
            <button
                type="button"
                className="callbar__button"
                disabled={busy}
                onClick={() => dispatch(startCall({ to: peerId, video: true, chatId }))}
                title={`Видеозвонок ${peerName || ''}`.trim()}
                aria-label="Видеозвонок"
            >
                ▣
            </button>
        </div>
    );
}
